import { combineReducers, createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; 
import cartReducer from './cartReducer';
import { loginReducer } from './loginReducer';

const persistConfig = {
  key: 'root',
  storage, 
  whitelist: ['login', 'cartItems'], 
};

const rootReducer = combineReducers({
  cartItems: cartReducer,
  login: loginReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  persistedReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__?.() 
);

export const persistor = persistStore(store); 
